import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Table, Row, Form } from 'reactstrap';
import { HiPencil } from 'react-icons/hi';
import { MdDelete } from 'react-icons/md';
import { IoIosAdd } from 'react-icons/io';
import { useQueryClient } from 'react-query';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

import './style.scss';
import AlertComponent from './../../../../components/Alert';
import ButtonComponent from './../../../../components/Buttons';
import InputField from 'components/Input/InputField';
import Loading from 'components/Loading';
import ModalComponent from './../../../../components/Modal';
import SearchComponent from './../../../../components/Search';
import Sidebar from './../Sidebar.js';
import { isNumberAnode } from 'helpers/index.js';
import { USE_CATEGORY_CONTRACT, ID_CATEGORY_CONTRACT_NOT_EDIT_AND_DELETE } from 'constants/MasterData';
import { MAX_LENGTH_40, MAX_LENGTH_3 } from 'constants/index.js';
import { useListCategoryContract } from './../../../../hook/useMasterData.js';
import { DATA_TYPE_NUMBER } from 'constants/index.js';
import {
  HTTP_EXPECTATION_FAILED,
  HTTP_INTERNAL_SERVER_ERROR,
  HTTP_OK,
  HTTP_NOT_ACCESS,
  HTTP_UNPROCESSABLE_ENTITY,
} from 'constants/StatusCode.js';
import { apiCreateCategoryContract, apiDeleteCategoryContract, apiUpdateCategoryContract } from 'api/masterData.js';
import $ from 'jquery';
import { ThemContext } from 'layouts/Admin';
import { ROLE_VIEW, DISABLE_ROLE, DISABLE_BUTTON_ROLE } from 'constants/index.js';

const DEFAULT_FORM_DATA = {
  id: 0,
  name: '',
  duration: '',
  error_name: '',
  error_duration: '',
};

const CategoryContract = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const dataInforUser = useContext(ThemContext);
  const [isShowModalAdd, setShowModalAdd] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [key_word, setKeyWord] = useState('');
  const [formAdd, setFormAdd] = useState(DEFAULT_FORM_DATA);
  const [isShowAlert, setShowAlert] = useState(false);
  const [message, setMessage] = useState('');
  const [textModal, setTextModal] = useState({
    title: t('masterData.addCategoryContract'),
    btn_submit: t('common.add'),
  });
  const { data: listCategoryContract, isLoading: isLoadingContract } = useListCategoryContract({ key_word });

  const handleSearch = (value) => {
    setKeyWord(value);
  };

  const addContract = () => {
    if (dataInforUser?.hr_permission?.master_data_permission === ROLE_VIEW) {
      return;
    }
    setShowModalAdd(true);
    setFormAdd({ ...formAdd, ...DEFAULT_FORM_DATA });
    setTextModal({
      title: t('masterData.addCategoryContract'),
      btn_submit: t('common.add'),
    });
  };

  const handleInput = (e) => {
    let _error = {};
    if (e.target.value) {
      _error = { ['error_' + e.target.name]: '' };
    }

    if ((e.target.name === 'duration' && isNumberAnode(e.target.value)) || e.target.name !== 'duration') {
      setFormAdd({ ...formAdd, [e.target.name]: e.target.value, ..._error });
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setFormAdd({ ...formAdd, error_name: '', error_duration: '' });
    var focus = true;
    if (!formAdd.name) {
      setFormAdd({ ...formAdd, error_name: t('common.pleaseFillOutThisField') });
      if (focus) {
        $('input[name=name]').focus();
        focus = false;
      }
      return;
    }
    if (formAdd.name.length > MAX_LENGTH_40) {
      setFormAdd({ ...formAdd, error_name: t('common.pleaseEnterLessThanFortyCharacters') });
      if (focus) {
        $('input[name=name]').focus();
        focus = false;
      }
      return;
    }
    if (formAdd.duration && formAdd.duration.toString().length > MAX_LENGTH_3) {
      setFormAdd({ ...formAdd, error_duration: t('common.pleaseEnterLessThanThreeNumber'), error_name: '' });
      if (focus) {
        $('input[name=duration]').focus();
        focus = false;
      }
      return;
    }
    setDisableButton(true);
    const data = {
      name: formAdd.name,
    };
    if (formAdd.duration) data.duration = formAdd.duration;

    let response = {};
    if (!formAdd.id) {
      response = await apiCreateCategoryContract(data);
    } else {
      response = await apiUpdateCategoryContract(formAdd.id, data);
    }

    if (
      response?.data.status === HTTP_INTERNAL_SERVER_ERROR ||
      response?.data.status === HTTP_EXPECTATION_FAILED
    ) {
      setMessage(response.data.messages);
      setShowAlert(true);
      setShowModalAdd(false);
      setDisableButton(false);
      queryClient.invalidateQueries(USE_CATEGORY_CONTRACT);
    }

    if (response?.status === HTTP_UNPROCESSABLE_ENTITY) {
      setDisableButton(false);
      if (response.data.messages?.name) {
        setFormAdd({ ...formAdd, error_name: response.data.messages.name[0] });
        if (focus) {
          $('input[name=name]').focus();
          focus = false;
        }
      }
      if (response.data.messages?.duration) {
        setDisableButton(false);
        setFormAdd({ ...formAdd, error_duration: response.data.messages.duration[0] });
        if (focus) {
          $('input[name=duration]').focus();
          focus = false;
        }
      }
      return;
    }
    if (response?.data?.status === HTTP_NOT_ACCESS && response?.data?.is_edit) {
      setDisableButton(false);
      setMessage(t('common.pleaseCheckAgainYouAreNotAuthorizedToUseThisFeature'));
      setShowAlert(true);
    }
    if (response?.data?.status === HTTP_OK) {
      setDisableButton(false);
      setShowModalAdd(false);
      setMessage(response.data.messages);
      setShowAlert(true);
      queryClient.invalidateQueries(USE_CATEGORY_CONTRACT);

      setTextModal({
        ...textModal,
        title: t('masterData.addCategoryContract'),
        btn_submit: t('common.add'),
      });
    }
  };

  const alertConfirm = (id) => {
    if (dataInforUser?.hr_permission?.master_data_permission === ROLE_VIEW) {
      return;
    }
    confirmAlert({
      title: t('common.doYouWantToDeletedData?'),
      buttons: [
        {
          label: t('common.cancel'),
          className: 'btn-alert-cancel',
        },
        {
          label: t('common.ok'),
          className: 'btn-alert-ok',
          onClick: async () => {
            const response = await apiDeleteCategoryContract(id);
            if (response?.data?.status === HTTP_NOT_ACCESS && response?.data?.is_edit) {
              setMessage(t('common.pleaseCheckAgainYouAreNotAuthorizedToUseThisFeature'));
              setShowAlert(true);
            }
            if (response?.data.status === HTTP_OK) {
              setMessage(response.data.messages);
              setShowAlert(true);
              queryClient.invalidateQueries(USE_CATEGORY_CONTRACT);
            }

            if (
              response?.data.status === HTTP_INTERNAL_SERVER_ERROR ||
              response?.data.status === HTTP_EXPECTATION_FAILED
            ) {
              setMessage(response.data.messages);
              setShowAlert(true);
              queryClient.invalidateQueries(USE_CATEGORY_CONTRACT);
            }
          },
        },
      ],
    });
  };

  const handleEdit = (CategoryContract) => {
    if (dataInforUser?.hr_permission?.master_data_permission === ROLE_VIEW) {
      return;
    }
    setFormAdd({
      ...formAdd,
      id: CategoryContract.id,
      name: CategoryContract.name,
      duration: CategoryContract.duration ? CategoryContract.duration : '',
      error_name: '',
    });
    setTextModal({ ...textModal, title: t('masterData.updateCategoryContract'), btn_submit: t('common.update') });
    setShowModalAdd(!isShowModalAdd);
  };

  return (
    <div>
      <Row>
        <Col lg={3} xl={2}>
          <Sidebar />
        </Col>
        <Col lg={9} xl={10}>
          <Row>
            <Col className="md-12">
              <div className="box-group d-flex float-right">
                <SearchComponent
                  txtPlaceholder={t('masterData.findData')}
                  addClass="input-search"
                  handleSearch={handleSearch}
                  defaultValue={key_word}
                />
                <ButtonComponent
                  text={t('common.add')}
                  icon={<IoIosAdd />}
                  addClass={`${dataInforUser?.hr_permission?.master_data_permission === ROLE_VIEW && DISABLE_BUTTON_ROLE
                    } ml-3`}
                  handleClick={addContract}
                />
              </div>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col className="md-12">
              <div className="table-list">
                <Table className="align-items-center table-hover" responsive>
                  <thead>
                    <tr>
                      <th scope="col">{t('masterData.contractCode')}</th>
                      <th scope="col">{t('masterData.categoryContractName')}</th>
                      <th scope="col">{t('masterData.contractExpirationWarningPeriod(Days)')}</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {listCategoryContract &&
                      listCategoryContract.map((item) => (
                        <tr key={item.id}>
                          <td>{item.id}</td>
                          <td className="text-bold">{item.name}</td>
                          <td>{item.duration}</td>
                          <td>
                            <div className="col-action d-flex float-right">
                              <div
                                className={`${dataInforUser?.hr_permission?.master_data_permission === ROLE_VIEW && DISABLE_ROLE
                                  } edit mr-2`}
                              >
                                <HiPencil onClick={() => handleEdit(item)}></HiPencil>
                              </div>
                              <div
                                className={`${dataInforUser?.hr_permission?.master_data_permission === ROLE_VIEW && DISABLE_ROLE
                                  } remove mr-3`}
                              >
                                {ID_CATEGORY_CONTRACT_NOT_EDIT_AND_DELETE.indexOf(item.id) < 0 &&
                                  (<MdDelete onClick={() => alertConfirm(item.id)}></MdDelete>)
                                }
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))}
                    {isLoadingContract && (
                      <tr>
                        <td colSpan={4}>
                          <Loading addClass="mt-2" />
                        </td>
                      </tr>
                    )}
                    {!isLoadingContract &&
                      (!listCategoryContract || (listCategoryContract && !listCategoryContract.length)) && (
                        <tr>
                          <td colSpan={4} className="error-no-data">
                            {t('common.notData')}
                          </td>
                        </tr>
                      )}
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      <ModalComponent
        toggle={() => setShowModalAdd(!isShowModalAdd)}
        isShowModal={isShowModalAdd}
        title={textModal.title}
      >
        <Form className="mt-3 box-show-none" onSubmit={handleSubmit}>
          <div className="mt-3">
            <InputField
              label={t('masterData.categoryContractName')}
              isRequired={true}
              variant="outlined"
              name="name"
              defaultValue={formAdd.name}
              onHandleInput={handleInput}
              maxLength={MAX_LENGTH_40}
              error={formAdd.error_name}
            />
          </div>

          <div className="mt-4">
            <InputField
              label={t('masterData.contractExpirationWarningPeriod(Days)')}
              isRequired={false}
              variant="outlined"
              name="duration"
              defaultValue={formAdd.duration}
              onHandleInput={handleInput}
              maxLength={MAX_LENGTH_3}
              error={formAdd.error_duration}
              dataType={DATA_TYPE_NUMBER}
            />
          </div>
          <Row className="mt-5">
            <Col className="md-6">
              <ButtonComponent
                text={t('common.cancel')}
                addClass="w-100 btn-bg-yellow2"
                handleClick={() => setShowModalAdd(false)}
              />
            </Col>
            <Col className="md-6">
              <ButtonComponent
                text={textModal.btn_submit}
                addClass="w-100"
                hasDisabled={disableButton}
                isLoading={disableButton}
                handleClick={() => setShowModalAdd(true)}
                type="submit"
              />
            </Col>
          </Row>
        </Form>
      </ModalComponent>

      <AlertComponent toggle={() => setShowAlert(!isShowAlert)} isShowAlert={isShowAlert}>
        {message}
      </AlertComponent>
    </div>
  );
};

export default CategoryContract;
